import { render, staticRenderFns } from "./RecurringPaymentsProductManagement.vue?vue&type=template&id=1683f11f&"
import script from "./RecurringPaymentsProductManagement.vue?vue&type=script&lang=ts&"
export * from "./RecurringPaymentsProductManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports